import { Prize } from "@/types";

interface PrizeDisplayProps {
  prize: Prize | null;
  onClaim: () => void;
  isClosing: boolean;
}

export function PrizeDisplay({ prize, onClaim, isClosing }: PrizeDisplayProps) {
  if (!prize) return null;

  const handleClaim = () => {
    const audio = new Audio('/sfx/start.aac');
    audio.play();
    onClaim();  // Call the onClaim prop after playing the audio
  };

  return (
    <div className={` overflow-visible fixed inset-0 flex items-center justify-center z-50 priceDisplayContent ${isClosing ? 'animate-fade-out' : 'animate-scale-in'}`}>
      <div className="w-full h-full flex items-center justify-center p-4 overflow-visible">
        <div className="absolute rounded-lg bg-gradient-to-r from-vaseline-blue/10 to-vaseline-pink/10 w-[100%] h-[100%] flex flex-col justify-start prizeMain max-w-[800px] overflow-visible">
          <div className="fixed inset-0 bg-[#258eda]/90 backdrop-blur-sm animate-fade-in" />
          <div className="absolute top-0 w-full h-full flex justify-center items-end overflow-hidden pointer-events-none">
            <img src="/imgs/c1.png" alt="c1" className="absolute w-full h-auto top-0 cG" id="c1" />
            <img src="/imgs/c2.png" alt="c2" className="absolute w-full h-auto top-0 cG" id="c2" />
            <img src="/imgs/c3.png" alt="c3" className="absolute w-full h-auto top-0 cG" id="c3" />
            <img src="/imgs/c4.png" alt="c4" className="absolute w-full h-auto top-0 cG" id="c4" />
            <img src="/imgs/c5.png" alt="c5" className="absolute w-full h-auto top-0 cG" id="c5" />
          </div>
          <div className="relative z-10 text-center mt-24">
            <div className="flex inset-0 flex justify-center items-center box_G3 mt-[85%]">
              <div className="absolute inset-0 flex justify-center items-center box_G2">
                <div className="absolute inset-0 flex justify-center items-center box_G">
                  <img src="/imgs/box2.png" alt="Image 1" className="absolute w-[357px] z-10" id="box2" />
                  <img src={`/imgs/${prize.filename}`} alt="gift" className="absolute w-[280px] gift" id="gift" />
                  <img src="/imgs/box3.png" alt="Image 2" className="absolute w-[357px] z-20" id="box3" />
                  <img src="/imgs/box1.png" alt="Image 3" className="absolute w-[434px] z-30 ml-[20px]" style={{ top: '-50px' }} id="box1" />
                </div>
              </div>
            </div>
          </div>
          <div className="flex relative justify-center mt-8">
            <img src="/imgs/lovely.png" alt="That's lovely!" className="w-[714px] h-auto" id="lovely" />
          </div>
          <div className="flex relative justify-center mt-16">
            <p className="text-center text-3xl text-white font-Quicksand ml-6 mr-6 w-[100%]" id="lovely_copy" style={{ textShadow: '3px 3px 2px #0a93c0' }}>
              {prize.description}
            </p>
          </div>
          <div id="btn2_GG">
            <div className="flex justify-center items-center mt-[10%]" id="btn2_G">
              <div className="button-container flex justify-center items-center mb-16">
                <div className="button" onClick={handleClaim}>
                  <div className="button-top-rect"></div>
                  <div className="button-bottom-rect"></div>
                  <span className="button-text font-Metric">THANK YOU!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
